import { connect } from 'react-redux'
import { mergeEventLabels } from '../../../actions/bookingCalendar/calendar/eventLabels'
import {
  doLabel,
  getEventLabels,
} from '../../../reducers/bookingCalendar/selectors/events'

const mapStateToProps = state => {
  return {
    doLabel: doLabel(state),
    eventLabels: getEventLabels(state),
  }
}

const mapDispatchToPropsToProps = dispatch => ({
  mergeEventLabels: labels => dispatch(mergeEventLabels(labels)),
})

export default connect(
  mapStateToProps,
  mapDispatchToPropsToProps,
)
